import React, { FC, useEffect, useRef } from 'react'

import { EuiFlyoutBody } from '@elastic/eui'
import { EuiFlyoutBodyProps } from '@elastic/eui/src/components/flyout/flyout_body'

export interface ConfigHeightEuiFlyoutBodyProps extends Partial<EuiFlyoutBodyProps> {
  height: string
}

const ConfigHeightEuiFlyoutBody: FC<ConfigHeightEuiFlyoutBodyProps> = ({ height, children, ...props }) => {
  const flyoutBodyRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!flyoutBodyRef.current) {
      return
    }

    const euiFlyoutBody__overflow = flyoutBodyRef.current.getElementsByClassName('euiFlyoutBody__overflow')[0] as HTMLDivElement
    const euiFlyoutBody__overflowContent = flyoutBodyRef.current.getElementsByClassName('euiFlyoutBody__overflowContent')[0] as HTMLDivElement

    if (euiFlyoutBody__overflow.style.height !== height) {
      euiFlyoutBody__overflow.style.height = height
    }

    if (euiFlyoutBody__overflowContent.style.height !== height) {
      euiFlyoutBody__overflowContent.style.height = height
    }
  })
  return (
    <div ref={flyoutBodyRef} style={{ height: height, overflowY: 'auto' }}>
      <EuiFlyoutBody {...props}>{children}</EuiFlyoutBody>
    </div>
  )
}

export default ConfigHeightEuiFlyoutBody
